<div
  class="call-log-details"
  [ngClass]="{ 'call-log-details-open': open, 'call-log-details-close': !open }"
  *ngIf="callItem">
  <div class="call-log-details__body">
    <button class="call-log-details__body-actions-btn">
      <i
        class="icon-small-close"
        (click)="close()"></i>
    </button>
    <div
      *ngIf="TABS.length !== 0"
      class="vox-tabs vox-tabs_dense">
      <div class="vox-tabs-container">
        <button
          *ngFor="let t of TABS"
          [ngClass]="{ active: t === tab }"
          (click)="tab = t"
          class="vox-btn vox-tab">
          <span
            class="icon-small-handset"
            *ngIf="t === 'details'"></span>
          <span
            class="icon-big-robot"
            *ngIf="t === 'ai'"></span>
          <span
            class="icon-small-mobile"
            *ngIf="t === 'sms'"></span>
          <span
            class="icon-small-link"
            *ngIf="t === 'webhooks'"></span>
          {{ "events.company-call-history.details.tabs.tab-" + t | Translate }}
        </button>
      </div>
    </div>
    <div class="vox-card vox-tab-content call-log-details-table mb-4">
      <ng-container *ngIf="tab === 'details'">
        <app-overview [callItem]="callItem"></app-overview>
      </ng-container>
      <ng-container *ngIf="tab === 'ai'">
        <app-ai-list [aiData]="callItem.ai"></app-ai-list>
      </ng-container>
      <ng-container *ngIf="tab === 'webhooks'">
        <app-webhook-list [webhooks]="callItem.webhooks"></app-webhook-list>
      </ng-container>
      <ng-container *ngIf="tab === 'sms' && callItem?.sms?.length > 0">
        <app-call-log-sms [smsItems]="callItem?.sms"></app-call-log-sms>
      </ng-container>
    </div>
    <!-- Call recording & voicemail -->
    <div
      class="media-container"
      *ngIf="callItem.recorded || callItem.voicemail">
      <div
        *ngIf="MEDIA_TABS.length !== 0"
        class="vox-tabs vox-tabs_dense">
        <div class="vox-tabs-container">
          <button
            *ngFor="let t of MEDIA_TABS"
            [ngClass]="{ active: t.label === mediaTab && !t.disabled }"
            [disabled]="t.disabled"
            (click)="mediaTab = t.label"
            class="vox-btn vox-tab">
            <span
              class="icon-big-voicemail"
              *ngIf="t.label === 'recording'"></span>
            <span
              class="icon-small-mic"
              *ngIf="t.label === 'voicemail'"></span>
            {{ "events.company-call-history.details.tabs.tab-" + t.label | Translate }}
          </button>
        </div>
      </div>
      <div class="vox-card vox-tab-content call-log-details-table m-b-lg">
        <ng-container *ngIf="mediaTab === 'recording'">
          <app-call-recording [callItem]="callItem"></app-call-recording>
        </ng-container>
        <ng-container *ngIf="mediaTab === 'voicemail'">
          <app-voicemail [callItem]="callItem"></app-voicemail>
        </ng-container>
      </div>
    </div>
  </div>
</div>
